import type { GenericTranslationsObject } from '@payloadcms/translations'

export const ja: GenericTranslationsObject = {
  $schema: '../translation-schema.json',
  'plugin-redirects': {
    customUrl: 'カスタムURL',
    documentToRedirect: 'リダイレクト先のドキュメント',
    fromUrl: 'リダイレクト元URL',
    internalLink: '内部リンク',
    redirectType: 'リダイレクトの種類',
    toUrlType: 'リダイレクト先URLの種類',
  },
}
